/**
 * theme scripts sweet space
 *
 * @author      Josh Cranwell <josh@werksmotorsport.com>
 * @copyright   The Sweet People
 * @version     1.0
 * @link        https://thesweetpeople.com
 * @since       5th January 2019
 */

// load jquery
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

// the new npm imports
require('bootstrap');
require('popper.js');
require('bootstrap-select');
require('slick-carousel');
require('scrollreveal');
require('lightgallery/lib/picturefill.min');
require('lightgallery');
require('lightgallery/modules/lg-thumbnail');
require('lightgallery/modules/lg-fullscreen');
require('lightgallery/lib/jquery.mousewheel.min');
global.jQueryBridget = require('jquery-bridget');
global.Masonry = require('masonry-layout');
global.imagesLoaded = require('imagesloaded');
global.Cookies = require('js-cookie');
global.ClipboardJS = require('clipboard');

// bridget for webpack
jQueryBridget('masonry', Masonry, $ );

/* the old code kit imports for reference
@codekit-prepend "../bower/bootstrap/dist/js/bootstrap"
@codekit-prepend "../bower/bootstrap-select/dist/js/bootstrap-select"
@codekit-prepend "../bower/slick-carousel/slick/slick"
@codekit-prepend "../bower/select2/dist/js/select2"
@codekit-prepend "../bower/scrollreveal/dist/scrollreveal"
@codekit-prepend "../bower/lightgallery/lib/picturefill.min"
@codekit-prepend "../bower/lightgallery/dist/js/lightgallery.min"
@codekit-prepend "../bower/lightgallery/modules/lg-thumbnail.min"
@codekit-prepend "../bower/lightgallery/modules/lg-fullscreen"
@codekit-prepend "../bower/lightgallery/lib/jquery.mousewheel.min"
@codekit-prepend "../bower/masonry-layout/dist/masonry.pkgd"
@codekit-prepend "../bower/imagesloaded/imagesloaded.pkgd.min"
@codekit-prepend "../bower/js-cookie/src/js.cookie"
@codekit-prepend "../bower/clipboard/dist/clipboard.min"
*/

// jQuery on ready
jQuery(document).ready(function ($) {

    const breakpoint = {
        // Small screen / phone
        sm: 576,
        // Medium screen / tablet
        md: 768,
        // Large screen / desktop
        lg: 992,
        // Extra large screen / wide desktop
        xl: 1200
    };

    //btn copy tooltip
    $('.btn-copy').tooltip({
        trigger: 'click',
        placement: 'bottom'
    });

    // set tool function
    function setTooltip(btn, message) {
        $(btn).tooltip('hide')
            .attr('data-original-title', message)
            .tooltip('show');
    }

    // hide tool tip function
    function hideTooltip(btn) {
        setTimeout(function() {
            $(btn).tooltip('hide')
                .removeAttr('data-original-title')
        }, 1000);
    }

    // clipboard new class
    let clipboard = new ClipboardJS('.btn-copy');

    // clipboard success copied
    clipboard.on('success', function(e) {
        e.clearSelection();
        setTooltip(e.trigger, 'Copied!');
        hideTooltip(e.trigger);
    });

    // clipboard error copied
    clipboard.on('error', function(e) {
        e.clearSelection();
        setTooltip(e.trigger, 'Failed!');
        hideTooltip(e.trigger);
    });


    // btn tooltip
    $(document).on('mouseenter', '.btn-tooltip', function(e) {

        // do the tooltip
        $(this).tooltip('show');

        // don't re function
        e.stopPropagation();

    });


    // menu draw open buttons
    $(document).on('click', '.btn-draw', function(e) {

        // get the draw class from the data
        let drawClass = $(this).data('draw');

        //console.log(drawClass);

        // body has class
        if( $('BODY').hasClass(drawClass) ) {

            // body
            $('BODY').removeClass(drawClass);

        //
        } else {

            // add class to body
            $('BODY').addClass(drawClass);

        }

        // prevent link defaults
        e.preventDefault();

    });


    // quicklook modal
    let $quicklookModal = $('#quicklook_modal');

    // quick look modal bs functions
    $quicklookModal.on('hidden.bs.modal', function (e) {

        // loading wrapper show
        $('.loading-wrapper', this ).removeClass('d-none');

        // product single remove
        $('.product-single').remove();

    });

    // btn quicklook
    $(document).on('click', '.btn-quicklook', function(e) {

        // current button product id
        let product_id = $(this).data('id');

        //console.log(product_id);

        // reload our form
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action   : 'product_quicklook',
                post_id  : product_id
            },
            success: function (data) {

                // loading wrapper show
                $('.loading-wrapper', $quicklookModal).addClass('d-none');

                // remove the old confirmed form
                $('.modal-body', $quicklookModal).append(data);

                // fire product gallery
                productGallery();

            }
        });

        // prevent link defaults
        e.preventDefault();

    });


    // btn tooltip
    $(document).on('click', '.btn-favourite', function(e) {

        // favs var
        let favourites;

        // current button product id
        let product_id = $(this).data('id');

        if( Cookies.get('_favourites') ) {

            // cookie data
            let data = Cookies.getJSON('_favourites');

            // if id does not exist in array
            if(data['favourites'].indexOf(product_id) === -1) {

                // add active class
                $(this).addClass('active').attr('data-original-title','Remove from favourites').tooltip('hide');

                // add new id to array
                data['favourites'].unshift(product_id);

            } else {

                // remove active class
                $(this).removeClass('active').attr('data-original-title','Add to favourites').tooltip('hide');

                // remove the id from the cookie array
                for( let i = 0; i < data['favourites'].length; i++){
                    if ( data['favourites'][i] === product_id) {
                        data['favourites'].splice(i, 1);
                    }
                }

            }

            // remove the local storage item
            Cookies.set('_favourites', {
                domain: document.domain,
                favourites: data['favourites']
            });

        } else {

            // add active class
            $(this).addClass('active').attr('data-original-title','Remove from favourites').tooltip('hide');

            // create new array with id
            favourites = [ product_id ];

            // create new cookie
            Cookies.set('_favourites', {
                domain: document.domain,
                favourites: favourites
            });

        }

        // prevent link defaults
        e.preventDefault();

    });


    // log out link
    $('.logout-link').on('click', function(e) {

        // prevent link defaults
        e.preventDefault();

        // remove the local storage item
        Cookies.remove('_siteauth', { path: '/', domain: document.domain });

        // reload page
        location.reload();

    });


    // footer fixed function
    let footerFixed = function() {

        // footer change objects
        let $footer             = $('#footer');
        let $wrapper            = $('BODY > .wrapper');

        // footer change vars
        let footerHeight        = $footer.outerHeight();

        // footer changes
        $footer.removeClass('initial-load');

        // wrapper padding
        $wrapper.css('padding-bottom', footerHeight + 'px');

    };


    // sorting drop down on change fire the form
    $('#product_sorting').on('change', ':input', function () {
        $('#product_sorting').submit();
    });


    // load images on the body
    let imgLoad = imagesLoaded('BODY');

    // images loaded desandro
    imgLoad.on( 'progress', function( instance, image ) {

        // global images
        $(image.img).parent().addClass('img-loaded');

    }).on( 'done', function( instance ) {

        // just for the product archive
        setTimeout(function() {
            $('#product_archive').find('.card-img-link > I').remove();
        }, 1000);

    });


    // initialize masonry
    let $grid = $('.masonry-grid').masonry({
        itemSelector: '.grid-item',
        percentPosition: true,
        horizontalOrder: true
    });


    // layout masonry after each time image loads
    $grid.imagesLoaded().progress( function() {
        $grid.masonry('layout');
    });


    // product archive row
    let $products = $('#product_archive > .row:first-child');


    // load more archive grid
    $('#load_more_products').on('click', function () {

        // our click button
        let $btn = $(this);

        // disable button
        $btn.html('<i class="far fa-circle-notch fa-spin"></i> Loading products').prop('disabled', true);

        // set currents empty array
        let currentProducts = [];

        // loop thought trough all products in products in archive
        $('[data-product]', $products).each(function (key, el) {

            // current product push elem
            currentProducts.push($(el).data('product'));

        });

        // post current page again
        $.post('', {

            // pass this data
            excludeItems: currentProducts

        }, function (html) {

            // find all the products the parent div
            let newProducts = $('#product_archive [data-product]', html).parent();

            // console.log($newProducts);

            // products append
            if ( newProducts.length < PostsPerPage ) {

                // hide button
                $btn.hide();

            }

            // products append
            $grid.masonry()
                .append( newProducts )
                .masonry( 'appended', newProducts )
                .imagesLoaded().progress( function(instance, image) {
                    $grid.masonry('layout');
                    $(image.img).parent().addClass('img-loaded');
                }).done( function () {
                    setTimeout(function () {
                        $('#product_archive').find('.card-img-link > I').remove();
                    }, 1000);
                })

        })

        // products loaded
        .done(function() {

            // re-enable button
            $btn.html('<i class="far fa-arrow-circle-down"></i> Load more products').prop('disabled', false);

        });

    });


    // product index sidebar open toggle
    $('#grid_toggler').on('click', 'A', function(e) {

        // make changes to the clicked button in question
        $(this).addClass('active').siblings().removeClass('active');

        // if element clicked is equal to large
        if( $(this).data('size') === 'large' ) {

            // add grid size large class
            $('#product_archive').addClass('grid-large');

            // update masonry layout
            $grid.masonry('layout');

            // update the local storage item
            Cookies.set("grid_large", 1);

        } else {

            // remove grid size large class
            $('#product_archive').removeClass('grid-large');

            // update masonry layout
            $grid.masonry('layout');

            // remove the local storage item
            Cookies.remove("grid_large");

        }

        // prevent link defaults
        e.preventDefault();

    });


    // slick product recent
    $('#product_favourites .slider').slick({
        autoplay: false,
        //autoplaySpeed: 2000,
        draggable: true,
        infinite: false,
        dots: false,
        speed: 1000,
        prevArrow: $('#product_favourites .slick-prev'),
        nextArrow: $('#product_favourites .slick-next'),
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: breakpoint.sm,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: breakpoint.md,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: breakpoint.lg,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: breakpoint.xl,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }
        ]
    });


    // slick product recent
    $('#product_recent .slider').slick({
        autoplay: false,
        //autoplaySpeed: 2000,
        draggable: true,
        infinite: false,
        dots: false,
        speed: 1000,
        prevArrow: $('#product_recent .slick-prev'),
        nextArrow: $('#product_recent .slick-next'),
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: breakpoint.sm,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: breakpoint.md,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: breakpoint.lg,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: breakpoint.xl,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }
        ]
    });


    // product gallery bizzle
    let productGallery = function() {

        // our product gallery
        let $oProductGallery = $('.product-gallery');

        // slick product gallery
        $('.slider', $oProductGallery).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false,
            dots: true,
            asNavFor: '.product-gallery .slider-nav'
        });

        // slick product gallery nav
        $('.slider-nav', $oProductGallery).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.product-gallery .slider',
            dots: false,
            arrows: false,
            focusOnSelect: true
        });

        // product gallery lightbox
        $oProductGallery.lightGallery({
            selector: '.lightgallery',
            exThumbImage: 'data-thumbnail'
        });

    }; productGallery();


    // load our sample form once
    $('#sample_modal_btn').one('click', function(e) {

        // reload our form
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action   : 'gf_sample_request_form',
                post_id  : post_id,
                sample_form_id  : sample_form_id
            },
            success: function (data) {

                // remove the old confirmed form
                $('.modal-body','#sample_modal').html(data);

            }
        });

    });


    // load our sample form once
    $('#enquiry_modal_btn').one('click', function(e) {

        // reload our form
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action   : 'gf_product_enquiry_form',
                post_id  : post_id,
                enquiry_form_id : enquiry_form_id
            },
            success: function (data) {

                // remove the old confirmed form
                $('.modal-body','#enquiry_modal').html(data);

            }
        });

    });


    // light weight event listener
    let waitForFinalEvent = function () {
        let b = {};
        return function (c, d, a) {
            a || (a = "I am a banana!");
            b[a] && clearTimeout(b[a]);
            b[a] = setTimeout(c, d)
        }
    }(); let fullDateString = new Date();


    // window resize
    $(window).on('resize', function () {

        // footer fixed
        footerFixed();

        // wait for final event before firing
        waitForFinalEvent(function(){

            // re init grid layout
            $grid.masonry('layout');

        }, 300, fullDateString.getTime());

    }).trigger('resize');


    // scroll functions
    $(window).scroll(function(e) {



    });


    // windown on load
    $(window).on('load', function() {



    });


    // code to trigger hacks on ajax gravity form render
    $(document).on('gform_post_render', function(e, form_id) {

        // remove weird introduction of inline display none
        //$('.gform_wrapper').removeAttr('style');

    });


});






